import React, { useEffect } from 'react';
import Footer from '../../components/footer';
import PrimaryButton from '../../components/primaryButton';
import { useDeviceType } from 'common-utilities';
import SheildIcon from '../../assets/svg/paytmSheild.svg';
import './style.scss';
import MobileFooter from '../../components/mobileFooter';
import { SCREEN_NAME, EVENT_CATEGORY } from '../../constants';
import { DEVICES, Pulse, NavigationHelpers, DeviceHelper } from 'common-utilities';

const screenName = SCREEN_NAME + '_success';
function Success({ state }) {
	const DEVICE = useDeviceType();
	const redirectPaytmDeepLink =
		sessionStorage && sessionStorage.getItem('REDIRECT_PAYTM_DEEPLINK');
	useEffect(() => {
		setTimeout(() => {
			Pulse.push({
				event_action: 'confirm_page_loaded',
				screenName,
				status: 'SUCCESS',
				platform: DeviceHelper.identify(),
				event_category: EVENT_CATEGORY
			});
		});
	}, []);
	return (
		<React.Fragment>
			<div className="successPageContainer">
				<div className="imageContainer">
					<img src={SheildIcon} alt="sheild-icon" />
				</div>
				<div className="heading">Logout Successful from All Devices & Linked Apps</div>
				<div className="text-container">
					You have been successfully logged out from all devices & linked apps.
				</div>
				<div className="infoContainer">
					{(state.name || '').length > 0 && (
						<div>
							<span>Name: </span>
							<span className="value">{state.name}</span>
						</div>
					)}
					{(state.moblieNumber || '').length > 0 && (
						<div>
							<span>Mobile No.:</span>
							<span className="value">{state.moblieNumber}</span>
						</div>
					)}
				</div>
				<div className="timeContainer">
					<span>Last login time:</span>
					<span className="value">{state.lastLoggedInTime}</span>
				</div>
				{DEVICE === DEVICES.DESKTOP ? (
					<div className="buttonContainer">
						<PrimaryButton
							onClick={() => {
								Pulse.push({
									event_action: 'goto_paytmweb_clicked',
									screenName,
									status: 'SUCCESS',
									event_category: EVENT_CATEGORY
								});
								NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
							}}
							oauth-id="login_btn"
						>
							Login
						</PrimaryButton>
					</div>
				) : DEVICE === DEVICES.MOBILE ? (
					<div className="mobileButtonContainer">
						<button
							className="button primary"
							onClick={() => {
								Pulse.push({
									event_action: 'goto_paytmapp_clicked',
									screenName,
									status: 'SUCCESS',
									event_category: EVENT_CATEGORY
								});
								NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
							}}
							oauth-id="login_btn"
						>
							Login
						</button>
					</div>
				) : null}
			</div>
			{DEVICE === DEVICES.DESKTOP ? (
				<Footer />
			) : (
				<MobileFooter
					onClick={() => {
						Pulse.push({
							event_action: 'download_clicked',
							screenName,
							status: 'SUCCESS',
							event_category: EVENT_CATEGORY
						});
						NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
					}}
					oauth-id="download_btn"
				>
					Download the Paytm App
				</MobileFooter>
			)}
		</React.Fragment>
	);
}
export default Success;
